<form #scaleForm="ngForm" class="stewards-modal">
  <div class="modal-header stewards-modal-header">
    <h4 class="modal-title text-truncate">{{meta.edit ? 'Edit' : 'Create'}} Sampling Request{{meta.title}}</h4>
    <button type="button" class="stewards-modal-close" (click)="cancel('cancel')" aria-label="Close">
      <fa name="times"></fa>
    </button>
  </div>
  <div class="modal-body stewards-modal-body" *ngIf="meta.loading">
    <div class="row">
      <div class="col text-center">
        <fa name="circle-o-notch" size="2x" animation="spin"></fa>
      </div>
    </div>
  </div>
  <div class="modal-body stewards-modal-body" *ngIf="!meta.loading">
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label class="stewards-modal-label">Add one or more Reasons</label>
          <ng-select name="requestReasons"
            [items]="possibleReasons"
            [loading]="meta.possibleReasons.loading"
             bindLabel="reason"
             bindValue="id"
             [multiple]="true"
             [closeOnSelect]="false"
             placeholder="Select one or more Reasons"
             [(ngModel)]="samplingRequest.reasons">
        </ng-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label class="stewards-modal-label" for="commentText">Optional Comment</label>
          <textarea class="form-control textarea-height" id="commentText" name="commentText" [(ngModel)]="samplingRequest.additionalComment"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!meta.saving" class="modal-footer stewards-modal-footer">
    <button type="button" class="btn btn-outline-dark stewards-modal-btn-close" (click)="cancel('cancel')">Close</button>
    <button *ngIf="samplingRequest" type="button" class="btn btn-danger" [disabled]="!entry.samplingId" (click)="remove()">Remove</button>
    <button *ngIf="samplingRequest" type="button" class="btn btn-primary" [disabled]="!samplingRequest.reasons || !samplingRequest.reasons.length" (click)="save()">Save</button>
  </div>
  <div *ngIf="meta.saving" class="modal-footer stewards-modal-footer stewards-modal-footer-loading">
    <fa name="circle-o-notch" animation="spin"></fa>
  </div>
</form>
